import React, { FC, useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CrossImg from '~/assets/images/cross.webp';
import CrossPreviewImg from '~/assets/images/cross_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import {
  DEFAULT_DISCOUNT_VALUE,
  FREE_AMOUNT_OF_DAYS,
  PrepaidBenefits,
} from '~/modules/prepaid/constants';
import analytics from '~/services/analytics';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  benefit: PrepaidBenefits;
  onSubmit: () => void;
};

const BenefitsDeclinedModal: FC<Props> = ({ benefit, onSubmit }) => {
  const { t } = useTranslation('modal');

  useEffect(() => {
    analytics.trackEvent('prepaid promo - fail modal show', {
      promo_type: benefit,
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Image src={CrossImg} preview={CrossPreviewImg} />
      </div>

      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('modal:non_prepaid_declined.title', 'Sorry, that card won’t work')}
      </Typography>

      <Typography
        variant={Typographies.TITLE_MEDIUM}
        component="div"
        className={styles.text}
      >
        {benefit === PrepaidBenefits.EXTRA_WEEK_TRIAL
          ? t('modal:non_prepaid_declined.text[0]', {
              amount: FREE_AMOUNT_OF_DAYS,
              defaultValue:
                'The card you entered is prepaid or unsupported. Use a regular credit/debit card to continue and get {{amount}} Extra Days for Free',
            })
          : t('modal:non_prepaid_declined.title[1]', {
              percent: DEFAULT_DISCOUNT_VALUE,
              defaultValue:
                'The card you entered is prepaid or unsupported. Use a regular credit/debit card to continue and get a {{percent}}% discount',
            })}
      </Typography>

      <Button
        className={styles.button}
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        {t('general:got_it', 'Got it')}
      </Button>
    </div>
  );
};

export default BenefitsDeclinedModal;
